import { render, staticRenderFns } from "./AutoFeed.vue?vue&type=template&id=1ae1daab&scoped=true"
import script from "./AutoFeed.vue?vue&type=script&lang=js"
export * from "./AutoFeed.vue?vue&type=script&lang=js"
import style0 from "./AutoFeed.vue?vue&type=style&index=0&id=1ae1daab&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_6szsw7whnsew6zajutnmcgkloi/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae1daab",
  null
  
)

export default component.exports